import { render, staticRenderFns } from "./FormSettingsContainer.vue?vue&type=template&id=1d70af6e"
import script from "./FormSettingsContainer.vue?vue&type=script&lang=js"
export * from "./FormSettingsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports